import React from 'react';
import { useTabList } from '../hooks/useTabList';

type TabListContainerProps = { children: React.ReactNode };

const TabListContainer = ({ children }: TabListContainerProps) => {
	const { blockClass } = useTabList();

	return (
		<div
			className={`listContainer ${blockClass ? `listContainer--${blockClass} vtex-tab-layout-0-x-listContainer--${blockClass}` : ''} vtex-tab-layout-0-x-listContainer flex w-100 flex-wrap justify-center`}
		>
			{children}
		</div>
	);
};

export default TabListContainer;
